import React from 'react';

const PaymentList = ({ payments }) => {
  return (
    <ul>
      {payments.map(payment => (
        <li key={payment.id}>
          {payment.client} - ${payment.amount} (Vence: {new Date(payment.dueDate).toLocaleDateString()})
        </li>
      ))}
    </ul>
  );
};

export default PaymentList;